import filter from 'lodash/filter';

import AccountTab from 'components/Settings/AccountSupplierTab/AccountSupplierTab';
import MyStoreTab from 'components/Settings/MyStoreTab/MyStoreTab';
import PaymentDetailsTab from 'components/Settings/PaymentDetailsTab/PaymentDetailsTab';
import PoliciesTab from 'components/Settings/PoliciesTab/PoliciesTab';
import TradingPoliciesTab from 'components/Settings/TradingPoliciesTab/TradingPoliciesTab';
import { IShippingPolicy } from 'types/settings/interfaces';

export const ACCOUNT_SUPPLIER = 'account_supplier';
export const POLICIES = 'policies';
export const TRADING_POLICIES = 'trading_policies';
export const MY_STORE = 'my_store';
export const PAYMENT_DETAILS = 'payment_details';

export enum SettingsTabPaths {
  AccountSupplier = 'tab=account_supplier',
  Policies = 'tab=policies',
  TradingPolicies = 'tab=trading_policies',
  MyStore = 'tab=my_store',
  PaymentDetails = 'tab=payment_details',
}

export const settingsTabs = [
  { key: ACCOUNT_SUPPLIER, label: 'Account & Supplier', children: <AccountTab /> },
  { key: POLICIES, label: 'Policies', children: <PoliciesTab /> },
  { key: TRADING_POLICIES, label: 'Trading Policies', children: <TradingPoliciesTab /> },
  { key: MY_STORE, label: 'My Store', children: <MyStoreTab /> },
  { key: PAYMENT_DETAILS, label: 'Payment Details', children: <PaymentDetailsTab /> },
];

export const syncProductsWarningText = 'Please fill all the mandatory fields and press Save, then you will be able to '
  + 'Synchronize products';

export const shippingValidator = async(value: string, setIsShippingError: IShippingPolicy['setIsShippingError']) => {
  if (filter(value, 'isAllowed').length) {
    setIsShippingError(false);

    return Promise.resolve();
  }

  setIsShippingError(true);

  return Promise.reject(new Error('At least one Country should be selected'));
};
